/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Error_Save_Set_LogInputs */



/**
* | output |
* | --- |
* | "Error saving set:" |
*
* @param {Tags_Manager_Error_Save_Set_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_error_save_set_log = /** @type {((inputs?: Tags_Manager_Error_Save_Set_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Error_Save_Set_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur lors de l'enregistrement de l'ensemble :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Speichern des Satzes:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante il salvataggio del set:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка сохранения набора:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al guardar el conjunto:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存数据集时出错：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セットの保存中にエラーが発生しました:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेट सहेजने में त्रुटि:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao salvar o conjunto:")
	return /** @type {LocalizedString} */ ("Error saving set:")
});